<div class="alert-card border-device" *ngIf="device && menu">
  <div class="d-flex justify-content-between mb-2 flex-column flex-lg-row">
    <div class="d-flex align-items-center">
      <div>
        <button class="btn btn-outline-success mr-2" (click)="individualAction(device,menu)">
          <em class="fa fa-retweet"></em>
        </button>
      </div>

      <div>
        <h5 class="m-0">{{menu.label | translate}}</h5>
        <p class="m-0">
          <em class="fa fa-clock"></em>
          {{device.device_status[menu.type_frame].received}}
        </p>
      </div>
    </div>
    <div>
      <div class="content-alert">
        <div class="item" *ngIf="menu.type_frame === 'BATTERY'">
          <div class="d-flex align-items-center">
            <div
              class="bg-alert w-100 justify-content-between"
              [ngStyle]="{'background-color': validateColorImage(device, 'battery','#B6D7A8','#F1C232','#EA9999')}"
            >
              <div class="d-flex align-items-center">
                <app-icon-battery
                  [value]="device.battery"
                  [height]="'13px'"
                  [width]="'25px'"
                  [font_size]="'13px'"
                  [color]="validateColorImage(device, 'battery','#009E0F','#FF9900','#CF2A27')"
                  [dark]="true"
                ></app-icon-battery>
                <p class="m-0 ml-2 font-weight-bold">{{ "alerts.general.battery" | translate }}</p>
              </div>
              <p class="m-0 text-dark">{{device.battery}}</p>
            </div>
          </div>
        </div>

        <div class="item" *ngIf="menu.type_frame === 'PANEL'">
          <div class="border-success d-flex align-items-center">
            <div
              class="bg-alert w-100 justify-content-between"
              [ngStyle]="{'background-color': validateColorImage(device, 'panel','#B6D7A8','#F1C232','#EA9999')}"
            >
              <div class="d-flex align-items-center">
                <app-image-color
                  [height]="'10px'"
                  [width]="'30px'"
                  [value]="'panel: ' + device.battery"
                  [url]="'img/icons/panel.svg'"
                  [color]="validateColorImage(device, 'panel','#009E0F','#FF9900','#CF2A27')"
                ></app-image-color>
                <p class="m-0 ml-2 font-weight-bold">{{ "alerts.general.panel" | translate }}</p>
              </div>
              <p class="m-0 text-dark">{{device.panel}}</p>
            </div>
          </div>
        </div>

        <div class="item" *ngIf="menu.type_frame === 'VERSION'">
          <div
            class="bg-alert w-100 bg-alert-success justify-content-between"
            ngbTooltip="A{{device.version}}"
          >
            <p class="m-0 ml-2 font-weight-bold">{{ "tables.version" | translate }}</p>
            <p class="m-0 text-dark">{{device.version}}</p>
          </div>
        </div>

        <div class="item" *ngIf="menu.type_frame === 'ON' || menu.type_frame === 'OFF'">
          <div class="border-success d-flex align-items-center">
            <div
              class="bg-alert w-100 justify-content-between"
              [ngbTooltip]="menu.type_frame === 'ON' ? ('clients.farm.on' | translate) : ('clients.farm.off' | translate)"
              [class]="validateActive(menu.type_frame === 'ON','power')"
            >
              <div class="d-flex align-items-center">
                <em
                  class="fa fa-power-off fa-1x"
                  [style.color]="menu.type_frame === 'ON' ? '#009E0F': '#CF2A27'"
                ></em>
                <p class="m-0 ml-2 font-weight-bold">
                  {{menu.type_frame === 'ON' ? ('clients.farm.on' | translate) : ('clients.farm.off' | translate)}}
                </p>
              </div>
              <em
                class="fa"
                [class]="!menu.type_frame === 'ON' ? 'fa-times-circle' : 'fa-check-circle'"
                [style.color]="menu.type_frame === 'ON' ? '#009E0F': '#CF2A27'"
              ></em>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div></div>
  </div>
  <div class="content-alert" *ngIf="menu.type_frame === 'WATERWISESENSORSSTATUS' ">
    <div class="item w-100">
      <b class="m-0">{{ "testing.request-sensors-hydro" | translate }}</b>
      <div class="container-sensors animated animate__fadeIn" [ngClass]="{'p-0': !options}">
        <div
          class="sensor m-0"
          *ngFor="let item of sensors_hydro"
          placement="bottom"
          triggers="hover focus"
          ngbTooltip="{{item.label | translate}}"
          [style.background-color]="item.validateLowColorSensor(device,item)"
          [ngClass]="{'d-none': !storageService.isAdmin() && !storageService.checks_parametry_preference[item.preference]}"
        >
          <div class="sensor-card">
            <h4 class="m-0 p-2">{{item.label_table | translate}}</h4>

            <h4 class="m-0 p-2">
              {{item.value(device,item)}}
              <small>{{item.measurementThreshold}}</small>
            </h4>
          </div>
        </div>
      </div>
    </div>
    <div class="item w-100">
      <b class="m-0">{{ "view-device.environmental-sensors" | translate }}</b>
      <div class="container-sensors animated animate__fadeIn" [ngClass]="{'p-0': !options}">
        <div
          class="sensor m-0"
          *ngFor="let item of sensors"
          placement="bottom"
          triggers="hover focus"
          ngbTooltip="{{item.label | translate}}"
          [style.background-color]="item.validateLowColorSensor(device,item)"
          [ngClass]="{'d-none': !storageService.isAdmin() && !storageService.checks_parametry_preference[item.preference]}"
        >
          <div class="sensor-card">
            <h4 class="m-0 p-2">{{item.label_table | translate}}</h4>

            <h4 class="m-0 p-2"
              [ngClass]="{'text-pressure': item.prop === 'pressure'}"
            >
              {{item.value(device,item)}}
              <small>{{item.measurementThreshold}}</small>
            </h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
